export default {
  hostUrl: import.meta.env.REACT_APP_HOST_URL,
  apiUrl: (version = 1): string => {
    return `${import.meta.env.REACT_APP_HOST_URL}/v${version}`;
  },
  clientId: import.meta.env.REACT_APP_CLIENT_ID,
  clientSecret: import.meta.env.REACT_APP_CLIENT_SECRET,
  accessTokenKey: 'access_token',
  refreshTokenKey: 'refresh_token',
  rememberMeKey: 'remember_me',
  wordsBatchSize: 15,
  displayMessage: '',
  facebookAppId: import.meta.env.REACT_APP_FACEBOOK_APP_ID,
  appleClientId: import.meta.env.REACT_APP_APPLE_CLIENT_ID,
  googleClientId: import.meta.env.REACT_APP_GOOGLE_CLIENT_ID,
};
